module.exports = __webpack_public_path__ + "img/tweet-content.4a7e6dc8.png";